/**
 * Created by Andrey Popov on 07.08.26
 */

const InviteFriendsWindow = Prefab.createWindow("invite_friends_window", "invitefriendswindow_prefab_json");

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    INVITE_FRIENDS_TEXT_COLOR: new cc.Color(153, 73, 43, 255)
});
